import React from 'react';
import { Button } from '@dotcom/crown-ui';
import { HistoryIcon } from './fragments/history-icon';
import styles from './history-controls.module.scss';

export type HistoryControlsViewProps = {
  canUndo: boolean;
  canRedo: boolean;
  isRestoring: boolean;
  lastRestoreError: Error | null;
  groupLabel: string;
  undoLabel: string;
  redoLabel: string;
  restoreFailedLabel: string;
  onUndo: () => void;
  onRedo: () => void;
};

export const HistoryControlsView = (props: HistoryControlsViewProps): React.ReactElement | null => {
  const showActions = props.canUndo || props.canRedo || props.isRestoring;

  if (!showActions && !props.lastRestoreError) {
    return null;
  }

  return (
    <div className={styles['history-controls']} role="group" aria-label={props.groupLabel}>
      {showActions && (
        <>
          <Button
            type="button"
            variant="text"
            aria-label={props.undoLabel}
            title={props.undoLabel}
            disabled={!props.canUndo || props.isRestoring}
            onClick={props.onUndo}
            className={styles['history-button']}
            testId="editor-undo"
          >
            <HistoryIcon direction="undo" />
            <span className={styles['history-button-label']}>{props.undoLabel}</span>
          </Button>
          <Button
            type="button"
            variant="text"
            aria-label={props.redoLabel}
            title={props.redoLabel}
            disabled={!props.canRedo || props.isRestoring}
            onClick={props.onRedo}
            className={styles['history-button']}
            testId="editor-redo"
          >
            <span className={styles['history-button-label']}>{props.redoLabel}</span>
            <HistoryIcon direction="redo" />
          </Button>
        </>
      )}
      {props.lastRestoreError && (
        <span className={styles['history-error']} role="alert" aria-live="assertive">
          {props.restoreFailedLabel}
        </span>
      )}
    </div>
  );
};
